import Store from 'store/store';
import { downloadZip } from 'client-zip';

Store.on('TEST_FILE_SHARING', async ({ asset, label }) => {
	const response = await fetch(asset);
	const blob = await response.blob();
	const fileExt = asset.split('.')[asset.split('.').length - 1];
	const file = new File([blob], label + '.' + fileExt, { type: blob.type });

	const shareOptions = asset && {
		files: [file]
	};

	Store.get().pressKit.set({ canShareFile: canShare(shareOptions) ? true : false});
});

Store.on('TOGGLE_PRESSKIT_OVERLAY', asset => {
	Store.get().pressKit.set({
		overlayOpen: asset
	});

	if (asset) {
		window.location.hash = '#' + asset;
	} else {
		history.replaceState('', document.title, window.location.pathname + window.location.search);
	}
});

Store.on('PRESSKIT_DOWNLOAD_ALL', async (assets) => {
	const assetList = assets.map(asset => asset.asset).filter(e => e);
	await downloadAll(assetList);
});

Store.on('DOWNLOAD_PRESSKIT_IMAGE', async ({ asset, label }) => {

	const isGIF = asset.endsWith('gif');
	const isPDF = asset.endsWith('pdf');

	if (isGIF || isPDF) {
		return downloadGifOrPdf(asset, label);
	} 

	let image = await new Promise((resolve, reject) => {
		const image = document.createElement('img');
		image.crossOrigin = 'anonymous';
		image.src = asset + (asset.includes('?') ? '&' : '?') + '_cors=1';
		image.onload = () => resolve(image);
		image.onerror = reject;
	});

	const c = document.createElement('canvas');
	const context = c.getContext('2d');
	c.width = image.naturalWidth;
	c.height = image.naturalHeight;
	context.drawImage(image, 0, 0);
	
	const link = document.createElement('a');
	const fileExt = asset.split('.')[asset.split('.').length - 1];
	link.href = c.toDataURL('image/' + fileExt);
	link.download = label + '.' + fileExt;
	link.style.display = 'none';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
});

Store.on('SHARE_PRESSKIT_IMAGE', async ({ asset, label }) => {
	const src = asset + (asset.includes('?') ? '&' : '?') + '_cors=1';
	const response = await fetch(src);
	const blob = await response.blob();
	const fileExt = asset.split('.')[asset.split('.').length - 1];
	const file = new File([blob], label + '.' + fileExt, { type: blob.type });
	const shareOptions = asset && {
		files: [file]
	};

	if (canShare(shareOptions)) {
		navigator.share(shareOptions);
	} else {
		// DONT SHOW SHARE ICON
	}
});

function canShare(shareOptions) {
	return shareOptions && navigator && navigator.canShare && navigator.canShare(shareOptions);
}

async function downloadGifOrPdf(src, url) {
	const result = await fetch(src);
	const blob = await result.blob();

	const link = document.createElement('a');
	link.href = window.URL.createObjectURL(blob);
	url = src.split('/')?.at(-1);
	link.download = url;

	link.dataset.downloadurl = ['application/octet-stream', link.download, link.href].join(':');
	link.click();
	link.remove();
	link.href = window.URL.revokeObjectURL(blob);
}

async function downloadAll(assets) {
	const files = [];
	if (!assets.length) {
		return;
	}

	await Promise.all(assets.map(async asset => {
		const src = asset + (asset.includes('?') ? '&' : '?') + '_cors=1';
		const code = await fetch(src);
		files.push(code);
	}));
	
	const blob = await downloadZip(files).blob();
	
	const link = document.createElement('a');
	link.href = window.URL.createObjectURL(blob);
	link.download = 'download.zip';
	link.click();
	link.remove();
	window.URL.revokeObjectURL(blob);
}